import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Http, Response } from '@angular/http';
import { constant } from '../../app.constants';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class OnDemandDriversService extends ParentService {
  private disabledBtnSchedule = new BehaviorSubject<boolean>(false);
  public disabledBtnSchedule$ = this.disabledBtnSchedule.asObservable();
  private formExpanded = new BehaviorSubject<boolean>(false);
  public formExpanded$ = this.formExpanded.asObservable();
  private actionNames = new BehaviorSubject<string[]>([]);
  public actionNames$ = this.actionNames.asObservable();

  constructor(private _http: Http) {
    super();
  }

  setActionNames(actionNames: string[]): void {
    this.actionNames.next(actionNames || []);
  }

  /**
   * @name getDriverByID
   * @description
   * @param driverid
   */
  getDriverByID(driverid: number) {
    return this._http
      .get(constant.URL_ONDEMAND_DRIVERS + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  getDriverDetails(driverid: number) {
    const url = `${constant.URL_GET_BACKGROUND_CHECK_DRIVER_DETAIL}/${driverid}`;
    return this._http
      .get(url, this.getHeader())
      .map((resp: Response) => resp.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getDrivers
   * @description
   */
  getDrivers() {
    return this._http
      .get(constant.URL_ONDEMAND_DRIVERS, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getReferrals
   * @description
   */
  getReferrals() {
    return this._http
      .get(constant.URL_GET_REFERRALS, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getFilterDriver
   * @description
   * @param filter
   * @param showDisable
   * @param statusid
   * @param rejectStid
   */
  getFilterDriver(filter, showDisable, statusid, rejectStid: string = ''): Observable<any> {
    const URL = constant.URL_ONDEMAND_DRIVERS +
    '/List?applicationStatusId=' + statusid +
    `&rejectionStatusId=${rejectStid}` +
    '&showInactive=' + showDisable +
    '&filter=' + filter;
    return this._http.get(URL, this.getHeader()).map(res => res.json());
  }


  /**
   * @name getTripHistory
   * @param driverid
   */
  getTripHistory(driverid) {
    return this._http
      .get(constant.URL_TRIP_HISTORY_DRIVER + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  getTripHistoryDateRange(driverid, startDate?, endDate?) {
    return this._http
      .get(constant.URL_TRIP_HISTORY_DRIVER + '/' +  driverid + '?startDate=' + startDate + '&endDate=' + endDate, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getBanks
   * @description
   */
  getBanks() {
    return this._http
      .get(constant.URL_GET_BANKS, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getLog
   * @description
   * @param driverid
   */
  getLog(driverid) {
    return this._http
      .get(constant.URL_LOG_DRIVER + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriverHistoy
   * @description
   * @param driverid
   */
  getDriverHistoy(driverid) {
    return this._http
      .get(constant.URL_DRIVER_HISTORY + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name postData
   * @description
   * @param data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_ONDEMAND_DRIVERS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * @name sendMessage
   * @description
   * @param data
   */
  sendMessage(data) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_SEND_MESSSAGE, bodyString, this.headerPost())
      .map((res: Response) => res.json());
  }

  /**
   * @name putData
   * @description
   * @param data
   */
  putData(data: any) {
    delete data.referral;
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_ONDEMAND_DRIVERS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  /**
   * @name deleteData
   * @description
   * @param data
   */
  deleteData(data: any) {
    return this._http
      .delete(`${constant.URL_USER_PROFILE}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }


  /**
   * @name getAllStatus
   * @description Obtiene los estados para on demand drivers y aplicants
   * @returns {Observable<any>}
   */
  getAllStatus(): Observable<any> {
    return this._http
      .get(constant.URL_GET_STATUS, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getRejectedReason
   * @description Devuelve los Rejected Reason.
   * @returns {Observable<any>}
   */
  getRejectedReason(): Observable<any>  {
    return this._http
    .get(constant.URL_GET_STATUS_REJECTED_REASON, this.getHeader())
    .map(res => res.json());
  }

  /**
   * @name getReports
   * @description
   * @param {number} driverid
   */
  getReports(driverid: number) {
    return this._http
      .get(constant.URL_GET_REPORTS + '/' + driverid, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getReportInfo
   * @description
   * @param {string} reportid
   */
  getReportInfo(reportid: string) {
    return this._http.get(constant.URL_GET_REPORT_INFO + '/' + reportid, this.getHeader()).map(res => res.json());
  }

  /**
   * @name runBackgroundCheck
   * @description
   * @param id
   */
  runBackgroundCheck(id) {
    return this._http
      .post(constant.URL_RUN_BACKGROUND + '/' + id, null, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name addInspection
   * @description INSPECTIONS
   */
  addInspection(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_ADD_INSPECTION, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * @name getDocuments
   * @description DOCUMENTS
   * @param {number} driverid
   */
  getDocuments(driverid: number) {
    return this._http
      .get(constant.URL_GET_DOCUMENTS + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name addDocument
   * @description
   * @param data
   */
  addDocument(data) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_ADD_DOCUMENT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getLicenses
   * @description LICENCES
   * @param {number} driverid
   * @param {boolean} active
   */
  getLicenses(driverid: number, active: boolean) {
    return this._http.get(constant.URL_GET_LICENSES + '/' + driverid + '/' + active, this.getHeader()).map(res => res.json());
  }

  /**
   * @name getVehicleLicenses
   * @description
   * @param {number} driverid
   * @param {number} vehicleid
   * @param {boolean} active
   */
  getVehicleLicenses(driverid: number, vehicleid: number, active: boolean) {
    return this._http
      .get(constant.URL_GET_VEHICLE_LICENSES + '/' + driverid + '/' + vehicleid + '/' + active, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getLicenseTypes
   * @description
   */
  getLicenseTypes() {
    return this._http
      .get(constant.URL_GET_LICENSE_TYPES, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getVLicenseTypes
   * @description
   */
  getVLicenseTypes() {
    return this._http
      .get(constant.URL_GET_VLICENSE_TYPES, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name addLicense
   * @description
   * @param data
   */
  addLicense(data) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_ADD_LICENSE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }


  /**
   * @name  validDriver
   * @description {number} Valid Driver
   * @param driverid
   * @returns {Observable<any>}
   */
  validDriver(driverid: number): Observable<any> {
    return this._http
      .get(constant.URL_VALID_DRIVER + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getUserDevice
   * @description get user device data by userprofileid
   * @param userprofileid user id
   * @returns {Observable<any>}
   */
  getUserDevice(userprofileid) {
    return this._http
      .get(constant.URL_DRIVER_DEVICE + '/' + userprofileid, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getUserDeviceById(userId) {
    return this._http
      .get(constant.URL_USER_DEVICE + '/' + userId, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getAvailableDriverSchedule(id: number) {
    const url = `${constant.DRIVER.MCT_DRIVER.BASE}/AvailableDriverSchedule/${id}`;
    return this._http.get(url, this.getHeader()).map(response => response.json());
  }

  isDisabledBtnSchedule(isDisabled: boolean) {
    this.disabledBtnSchedule.next(isDisabled);
  }

  setFormExpanded(isExpanded: boolean): void {
    this.formExpanded.next(isExpanded);
  }

  sendVideoDriver(data: any) {
    const url = `${constant.URL_SEND_VIDEO_DRIVER}`;
    return this._http
      .post(url, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  updateActive(data: any) {
    return this._http
      .put(constant.URL_UPDATE_ACTIVE, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
   /**
   * @name getModulesCourses
   * @description Courses
   * @param {number} driverid
   */
   getModulesCourses(driverid: number) {
    return this._http
      .get(constant.URL_GET_MODULES_COURSES + driverid, this.getHeader())
      .map(res => res.json());
  }
  downloadCertificationPDF(driverId: number) {
    return this._http
      .get(constant.URL_GET_DOWNLOAD_CERTIFICATED + driverId, this.getFileHeaders())
      .map(res => res.json());
  }

  changeActive(vehicleId: any) {
    const url = `${constant.URL_VEHICLE_CHANGE_ACTIVE}?vehicleId=${vehicleId}`;
    return this._http
      .put(url, {}, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  verifyDriverLicense(userId: number) {
    const url = `${constant.URL_VERIFY_LICENSE_ON_DEMAND_DRIVER}/${userId}`;
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  verifyDriverLicenseMassive(driverIds: number[]) {
    return this._http
      .post(constant.URL_POST_VERIFYLICENSE_MASSIVE, driverIds, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  public reactivateAccount(driverId: number): Observable<any> {
    const url = `${constant.URL_REACTIVE_ACCOUNT_ON_DEMAND_DRIVER}/${driverId}`;
    return this._http
      .put(url, {}, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/on-demand-drivers.service.ts